import axios from "axios";
import { MAIN_URL } from "../../Configurations/Urls";

const CODE_KEYS = ["employee_code", "person_code", "intern_code"];
const ID_KEYS = ["organization_person_id"];

let directory = {
  orgId: null,
  promise: null,
  byId: new Map(),
  byCode: new Map(),
};

function usableText(value) {
  if (value == null || typeof value === "object") return "";
  const text = String(value).trim();
  if (!text || text === "-" || text === "—" || text.toLowerCase() === "null") return "";
  return text;
}

function readField(row, getNestedValue, key) {
  const direct = usableText(row?.[key]);
  if (direct) return direct;
  if (typeof getNestedValue !== "function") return "";
  try {
    return usableText(getNestedValue(row, key));
  } catch (error) {
    return "";
  }
}

export function ensurePersonPhotoDirectory(orgId) {
  if (!orgId) return Promise.resolve(directory);
  if (directory.orgId === String(orgId) && directory.promise) return directory.promise;

  const next = {
    orgId: String(orgId),
    byId: new Map(),
    byCode: new Map(),
    promise: null,
  };

  next.promise = axios
    .get(`${MAIN_URL}/api/organizations/${orgId}/employee/profile-images`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then((response) => {
      const rows = Array.isArray(response.data?.data) ? response.data.data : [];
      rows.forEach((row) => {
        const url = usableText(row?.profile_image_url);
        if (!url) return;
        if (row.organization_person_id) {
          next.byId.set(String(row.organization_person_id), url);
        }
        [row.person_code, row.employee_code, row.intern_code].forEach((code) => {
          const key = usableText(code).toLowerCase();
          if (key) next.byCode.set(key, url);
        });
      });
      return next;
    })
    .catch(() => next);

  directory = next;
  return next.promise;
}

export function matchPersonPhoto(loaded, row, getNestedValue) {
  if (!loaded || !row) return "";
  for (const key of ID_KEYS) {
    const id = readField(row, getNestedValue, key);
    if (id && loaded.byId.has(id)) return loaded.byId.get(id);
  }
  for (const key of CODE_KEYS) {
    const code = readField(row, getNestedValue, key).toLowerCase();
    if (code && loaded.byCode.has(code)) return loaded.byCode.get(code);
  }
  return "";
}
